function parseCoordinatesBlock(body) {
  const trimmed = body.trim();
  if (!trimmed) return [];
  const tokens = trimmed.split(/\s+/).filter(Boolean);
  const out = [];
  for (const token of tokens) {
    const parts = token.split(',').map((s) => parseFloat(s.trim()));
    const lon = parts[0];
    const lat = parts[1];
    if (Number.isFinite(lat) && Number.isFinite(lon)) {
      out.push([lat, lon]);
    }
  }
  return out;
}

/**
 * Extrae puntos [lat, lng] del primer LineString de un documento KML.
 * @param {string} kmlText
 * @returns {[number, number][]}
 */
export function parseKmlLineStringToLeaflet(kmlText) {
  const match = kmlText.match(/<LineString>[\s\S]*?<coordinates>\s*([\s\S]*?)\s*<\/coordinates>/i);
  if (!match) return [];
  return parseCoordinatesBlock(match[1]);
}

/**
 * Todos los LineString del KML, en orden documento (p. ej. ida y luego vuelta).
 * @param {string} kmlText
 * @returns {Array<[number, number][]>}
 */
export function parseKmlAllLineStringsToLeaflet(kmlText) {
  const re = /<LineString>[\s\S]*?<coordinates>\s*([\s\S]*?)\s*<\/coordinates>/gi;
  const rings = [];
  let m = re.exec(kmlText);
  while (m !== null) {
    const ring = parseCoordinatesBlock(m[1]);
    if (ring.length >= 2) rings.push(ring);
    m = re.exec(kmlText);
  }
  return rings;
}
